module.exports = __webpack_public_path__ + "img/woman-sm.a314d1c6.svg";